import transfer from "@/store/modules/transfer"

class Rate {
    constructor(data) {
        this.id = (data.id) ? data.id : (data._id) ? data._id : null
        this.from_currency_code = data.from_currency_code || null
        this.to_currency_code = data.to_currency_code || null
        this.value = data.value || 0
        this.get = data.get || 0
        this.send = data.send || 0
        this.comissions = {
            transfer: data.comissions && data.comissions.transfer ? data.comissions.transfer : 0,
            bill: data.comissions && data.comissions.bill ? data.comissions.bill : 0,
            topup: data.comissions && data.comissions.topup ? data.comissions.topup : 0,
            withdraw: data.comissions && data.comissions.withdraw ? data.comissions.withdraw : 0
        }
        this.limits = {
           transfer: data.limits && data.limits.transfer ? data.limits.transfer : null,
           bill: data.limits && data.limits.bill ? data.limits.bill : null,
           topup: data.limits && data.limits.topup ? data.limits.topup : null,
           withdraw: data.limits && data.limits.withdraw ? data.limits.withdraw : null
        }
        this.pays_get_codes = data.pays_get_codes || []
        this.pays_send_codes = data.pays_send_codes || []
        this.get_bank_codes = data.get_bank_codes || []
        this.send_bank_codes = data.send_bank_codes || []
        this.get_banks = data.get_banks || []
        this.send_banks = data.send_banks || []
    }

    toObject() {
        return {
            id: this.id,
            from_currency_code: this.from_currency_code,
            to_currency_code: this.to_currency_code,
            value: this.value,
            get: this.get,
            send: this.send,
            comissions: this.comissions,
            limits: this.limits,
            pays_get_codes: this.pays_get_codes,
            pays_send_codes: this.pays_send_codes,
            get_bank_codes: this.get_bank_codes,
            send_bank_codes: this.send_bank_codes,
            get_banks: this.get_banks,
            send_banks: this.send_banks
        }
    }
}

class RateList {
    constructor(list) {
        this.items = (list || []).map(item => new Rate(item))
    }

    toArrayObj() {
        return this.items.map(item => item.toObject())
    }
}

export { Rate, RateList }